import { mailApiPost, type ApiResult } from "@/lib/api/client";

export type MailOnlyOfficeEditorType = "desktop" | "mobile" | "embedded";

export type MailOnlyOfficeConfigResponse = {
  success: boolean;
  document_server_url: string;
  config: Record<string, unknown> & { token?: string };
  message?: string;
  error?: string;
};

export function fetchMailOnlyOfficeConfig(params: {
  accountId: number;
  folder: string;
  uid: number;
  part: string;
  filename: string;
  mime?: string;
  size?: number;
  editorType?: MailOnlyOfficeEditorType;
}): Promise<ApiResult<MailOnlyOfficeConfigResponse>> {
  return mailApiPost<MailOnlyOfficeConfigResponse>("onlyoffice/config.php", {
    accountId: params.accountId,
    folder: params.folder,
    uid: params.uid,
    part: params.part,
    filename: params.filename,
    mime: params.mime ?? "",
    size: params.size ?? 0,
    editor_type: params.editorType ?? "embedded",
  });
}
